import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// import bg from "./../../data/bg.jpg";
import TopBar from "./TopBar";
import { getSearchedCreators } from "../../service/api";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function UserAddCreator() {
  const [profiles, setProfiles] = useState([]);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const fetchData = async () => {
      const user_data = JSON.parse(sessionStorage.getItem("userdata"));
      if (!user_data) navigate("/user/login");

      let data = await getSearchedCreators(e.target.value || null);
      setProfiles(data.creators);
    };
    fetchData();
  };

  return (
    <div className="bg flex flex-col bg h-full min-h-screen">
      <TopBar />
      <div>
        <div className="flex justify-center m-4">
          <div className="rounded-full px-2 flex w-11/12 md:w-3/5 items-center border-2 text-slate-700 border-slate-300 text-md bg-slate-300">
            <input
              type="text"
              name="text"
              placeholder="Search creators"
              className="rounded-l-3xl border-0 bg-transparent px-3 py-2 outline-0 w-full"
              onChange={handleChange}
            />
            <div className="w-1/6 h-full flex justify-center items-center rounded-r-3xl">
              <FontAwesomeIcon icon={faSearch} size="lg" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-8 justify-center">
        {profiles.length > 0 &&
          profiles.map((profile, index) => (
            <div
              className="flex flex-col justify-center border border-slate-600 text-red-600 items-center py-3 px-5 bg-slate-200 rounded-xl text-center"
              key={index}
              onClick={(e) => {
                e.preventDefault()
                navigate(`/user/creator/${profile.email}`)
              }}
            >
              <img
                className="h-36 w-36 rounded-full border border-black"
                src={"" + profile.image}
                alt=""
              />
              <h1 className="text-3xl mt-1 font-semibold">{profile.name}</h1>
            </div>
          ))}
      </div>
    </div>
  );
}

export default UserAddCreator;
